import { useMsal } from "@azure/msal-react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApproverPage from "../ApprovalComponent/ApproverPage";
import CampaignHome from "../CampaignComponents/Home";
import ClosureForm from "../ClosureComponents/closureForm";
import DesignerPage from "../DesignerComponents/Home";
import { baseURL } from "../Constant";
import DashboardComponent from "../DashboardComponent";
import CertificateForm from "../E-CertificateComponent/certificateForm";
import MyContentPage from "../MyContentComponent/MyContentPage";
import NudgeForm from "../NudgeComponent/nudgeForm";
import RecognitionForm from "../RecognitionComponent/recognitionForm";
import { getUserMaintanenceData } from "../Redux/UserMaintanence";
import ReminderForm from "../ReminderComponent/ReminderForm";
import LaunchDipaMailForm from "../SocialEngagement/Dipa/LaunchDipaMailForm";
import TeaserDipaMailForm from "../SocialEngagement/Dipa/TeaserDipaMailForm";
import FollowupMailForm from "../SocialEngagement/VivaEngane/FollowupMailForm";
import RecognitionMailForm from "../SocialEngagement/VivaEngane/RecognitionMailForm";
import LaunchMailForm from "../SocialEngagement/VivaEngane/launchMailForm";
import NudgeMailForm from "../SocialEngagement/VivaEngane/nudgeMailForm";
import TeaserForm from "../TeaserComponent/TeaserForm";
import TestimonialForm from "../TestimonialComponent/testimonialForm";
import AdminTable from "../UserMaintananence/AdminTable";
import DefaultScreen from "./DefaultScreen";
import "./DisplayedScreen.css";
import LaunchDataDisplay from "./LaunchDataDisplay";
import MailForm from "./MailForm";
import WelcomeNameContainer from "./WelcomeNameContainer";
import Testimonials from "../Testimonials";
import VideoComponent from "./VideoComponent";
import UserGuideComponent from "./UserGuideComponent";
import Design from "../DesignComponents/Design";

const DisplayedScreen = ({
 mailerChild,
 mailerParent,
 isMailGenerated,
 setIsMailGenerated,
 modalResponse,
 setModalResponse,
 isLoading,
 text,
 setText,
 handleRegeneration,
 programName,
 setProgramName,
 launchDate,
 setLaunchDate,
 keyPoints,
 setKeyPoints,
 targAudience,
 setTargAudience,
 callToAction,
 setCallToAction,
 contactInfo,
 setContactInfo,
 additionalResources,
 setAdditionalNotes,
 personalizedMsg,
 setPersonalizedMsg,
 additionalNotes,
 setAdditionalResources,
 handleReset,
 setIntroduction,
 handleClickOpen,
 open,
 setOpen,
 handleGenerate,
 navigatedToForm,
 setNavigatedToForm,
 categoryName,
 setCategoryName,
 setAdditionalInfo,
 additionalInfo,
 categoryNameTeaser,
 setMailerChild,
 setMailerParent,
 setCategoryNameTeaser,
 categoryNameReminder,
 setCategoryNameReminder,
 categoryNameNudge,
 setCategoryNameNudge,
 categoryNameRecognition,
 setCategoryNameRecognition,
 setCategoryNameClosure,
 categoryNameClosure,
 setLaunchCampaignVal,
 launchCampaignVal,
 setCampaignItem,
 campaignItem,
 videoUrl,
 pdfUrl
 // activeScreen,
 // setActiveScreen,
}) => {
 const [userRoleAccess, setUserRoleAccess] = useState([]);
 const [programList,setProgramList]=useState([]);
 const [campaignsByUser, setCampaignsByUser] = useState("");
 const [flag, setFlag] = useState(0);
 const userData = useSelector((state) => state.userRoles.UserMaintanenceData);
 const dispatch = useDispatch();

 const { instance } = useMsal();
 const activeAccount = instance.getActiveAccount();
 let loggedInEnterpriseId = "";
 if (activeAccount) {
  loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
 }

 useEffect(()=>{
  const getProgramNames=async()=>{
    const response= await axios.get(`${baseURL}/uniqueProgramNames`);
    setProgramList(response.data);
  }
  getProgramNames();
 },[]);

 useEffect(() => {
  const fetchCampaignsData = async () => {
   try {
    const response = await axios.get(
     `${baseURL}/campaignsByUser/${loggedInEnterpriseId}`
    );
    setCampaignsByUser(
     response.data?.filter((campaign) => campaign.status !== "Declined")
    );
   } catch (err) {
    console.log(err.message);
   }
  };
  fetchCampaignsData();
  dispatch(getUserMaintanenceData());
 }, [flag]);

 useEffect(() => {
  setUserRoleAccess(userData);
 }, [userData]);

 let filteredUserAccesRole =
  userRoleAccess.length !== 0
   ? userRoleAccess.filter((user) => {
      return user.Enterprise_ID === loggedInEnterpriseId;
     })
   : [];

 let typeOfUser =
  filteredUserAccesRole.length === 0
   ? "request_access"
   : filteredUserAccesRole[0].Admin === "yes"
   ? "Admin"
   : filteredUserAccesRole[0].Approver === "yes"
   ? "Approver"
   : filteredUserAccesRole[0].Requestor === "yes"
   ? "Requestor"
   : "inactive";

 return (
  <>
   {mailerChild == "testimonials" ? <Testimonials/>
   :mailerChild == "Launch" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : isMailGenerated == "generateOutput" ? (
     <div className="data-display-new">
      <LaunchDataDisplay
       isMailGenerated={isMailGenerated}
       setIsMailGenerated={setIsMailGenerated}
       programName={programName}
       navigatedToForm={navigatedToForm}
       setNavigatedToForm={setNavigatedToForm}
       modalResponse={modalResponse}
       isLoading={isLoading}
       setModalResponse={setModalResponse}
       text={text}
       setText={setText}
       setOpen={setOpen}
       open={open}
       handleRegeneration={handleRegeneration}
       mailerParent={mailerParent}
       mailerChild={mailerChild}
       categoryName={categoryName}
       handleReset={handleReset}
      />
     </div>
    ) : (
     <MailForm
      programList={programList}
      campaigns={campaignsByUser}
      modalResponse={modalResponse}
      setModalResponse={setModalResponse}
      programName={programName}
      setProgramName={setProgramName}
      launchDate={launchDate}
      setLaunchDate={setLaunchDate}
      keyPoints={keyPoints}
      setKeyPoints={setKeyPoints}
      targAudience={targAudience}
      setTargAudience={setTargAudience}
      callToAction={callToAction}
      setCallToAction={setCallToAction}
      contactInfo={contactInfo}
      setContactInfo={setContactInfo}
      additionalResources={additionalResources}
      setAdditionalNotes={setAdditionalNotes}
      personalizedMsg={personalizedMsg}
      setPersonalizedMsg={setPersonalizedMsg}
      additionalNotes={additionalNotes}
      setAdditionalResources={setAdditionalResources}
      handleReset={handleReset}
      handleClickOpen={handleClickOpen}
      open={open}
      setOpen={setOpen}
      handleGenerate={handleGenerate}
      navigatedToForm={navigatedToForm}
      setNavigatedToForm={setNavigatedToForm}
      isMailGenerated={isMailGenerated}
      setIsMailGenerated={setIsMailGenerated}
      setAdditionalInfo={setAdditionalInfo}
      categoryName={categoryName}
      setCategoryName={setCategoryName}
      additionalInfo={additionalInfo}
      setIntroduction={setIntroduction}
      setLaunchCampaignVal={setLaunchCampaignVal}
      launchCampaignVal={launchCampaignVal}
      setCampaignItem={setCampaignItem}
      campaignItem={campaignItem}
     />
    )
   ) : mailerChild == "approver" ? (
    <ApproverPage
    // activeScreen={activeScreen}
    // setActiveScreen={setActiveScreen}
    />
   ) : mailerChild == "mycontent" ? (
    <MyContentPage />
   ) : mailerChild == "designer" ? (
    <DesignerPage/>
   ): mailerChild == "user_maintenance" ? (
    // <UserMaintenanceContent />
    <AdminTable />
   ) : mailerChild == "dashboard" ? (
    <DashboardComponent />
   ) : mailerChild == "buildcam" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="campaign" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <CampaignHome setFlag={setFlag} typeOfUser={typeOfUser}/>
    )
   ) : mailerChild == "Teaser" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <TeaserForm
       programList={programList}
       campaigns={campaignsByUser}
       categoryNameTeaser={categoryNameTeaser}
       setCategoryNameTeaser={setCategoryNameTeaser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Reminder" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <ReminderForm
       programList={programList}
       campaigns={campaignsByUser}
       categoryNameReminder={categoryNameReminder}
       setCategoryNameReminder={setCategoryNameReminder}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Nudge" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <NudgeForm
       programList={programList}
       campaigns={campaignsByUser}
       categoryNameNudge={categoryNameNudge}
       setCategoryNameNudge={setCategoryNameNudge}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Recognition" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <RecognitionForm
      programList={programList}
       campaigns={campaignsByUser}
       categoryNameRecognition={categoryNameRecognition}
       setCategoryNameRecognition={setCategoryNameRecognition}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Closure" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <ClosureForm
       programList={programList}
       campaigns={campaignsByUser}
       categoryNameClosure={categoryNameClosure}
       setCategoryNameClosure={setCategoryNameClosure}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "E-Certificate" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <CertificateForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Testimonial" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <TestimonialForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Viva-Launch/Nomination/Registration" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Viva-Engage-launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <LaunchMailForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Viva-Follow-up/Reminder" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Viva-Engage-Reminder" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <FollowupMailForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Viva-Nudge" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Viva-Engage-Nudge" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <NudgeMailForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Viva-Recognition" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Viva-Engage-Recognition" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <RecognitionMailForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Dipa-Teaser" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Dipa-Teaser" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <TeaserDipaMailForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) : mailerChild == "Dipa-Launch" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="Dipa-Launch" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <>
      <LaunchDipaMailForm
       campaigns={campaignsByUser}
       mailerChild={mailerChild}
       mailerParent={mailerParent}
       setMailerChild={setMailerChild}
       setMailerParent={setMailerParent}
      />
     </>
    )
   ) :mailerChild =="Demo-Video"?(
    <Stack>
    <Stack sx={{ width: "100%" }}>
     <WelcomeNameContainer currentComp="CommsBuilder Demo" />
    <VideoComponent videoUrl={videoUrl}/>
    </Stack>
    </Stack>
   ):mailerChild =="user-guide"?(
    <Stack>
    <Stack sx={{ width: "100%" }}>
    <WelcomeNameContainer currentComp="User Guide" pdfUrl={pdfUrl}/>
    <UserGuideComponent pdfUrl={pdfUrl}/>
    </Stack>
    </Stack>
   ): mailerChild == "Design" ? (
    typeOfUser === "inactive" || typeOfUser === "request_access" ? (
     <Stack>
      <Stack sx={{ width: "100%" }}>
       <WelcomeNameContainer currentComp="campaign" />
       <Stack sx={{ width: "71%", margin: "100px auto 0 auto" }} spacing={2}>
        {typeOfUser === "inactive" && (
         <Alert severity="info">
          Access revoked. Please write to ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
        {typeOfUser === "request_access" && (
         <Alert severity="info">
          Access restricted. To get access to CommsBuilder, please write to
          ATCI.L-TT.CommsBuilder.Support@accenture.com
         </Alert>
        )}
       </Stack>
      </Stack>
     </Stack>
    ) : (
     <Design setFlag={setFlag} typeOfUser={typeOfUser} />
    )
   ) : (
    <DefaultScreen />
   )}
  </>
 );
};

export default DisplayedScreen;
